import angular from 'angular';
import uiRouter from 'angular-ui-router';
import VehicleComponent from './vehicle.component';

let VehicleModule = angular
  .module('Vehicle', [uiRouter])

  .config($stateProvider => {
    'ngInject';
    $stateProvider
      .state('newVehicle', {
        url: '/vehicles/new',
        component: 'vehicle',
        parent: 'main',
        data: {
          permissions: {
            only: ['OPERATOR'],
            redirectTo: 'home'
          }
        },
        resolve: {}
      })
      .state('editVehicle', {
        url: '/vehicles/:id',
        component: 'vehicle',
        parent: 'main',
        data: {
          permissions: {
            only: ['OPERATOR'],
            redirectTo: 'home'
          }
        },
        resolve: {
          vehicle: (VehiclesService, $stateParams) => {
            return VehiclesService.findById($stateParams.id, {
              include: [
                'createdByUser',
                'updatedByUser',
                'brand',
                'engineBrand',
                'chassisBrand',
                'province',
                'holder',
                'fleet'
              ]
            });
          }
        }
      });
  })
  .component('vehicle', VehicleComponent).name;

export default VehicleModule;
